<template>
	<div class="splash fade-out-box">
		<img src="@/assets/img/bi/bi.svg" alt="404" class="icon_404" loading="lazy" />
		<p>대가의 선택</p>
	</div>
</template>

<script setup></script>

<style scoped>
.splash {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 1.9rem;
	z-index: 1000;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: var(--color-bg);
}
.splash img {
	width: 10rem;
	height: 10rem;
	object-fit: contain;
}
.splash p {
	font-size: var(--space-large);
	font-weight: var(--font-w-semi-bold);
	line-height: 2.387rem;
	color: #ffffff;
}
.fade-out-box {
	animation: fadeout 2s;
	-moz-animation: fadeout 2s; /* Firefox */
	-webkit-animation: fadeout 2s; /* Safari and Chrome */
	-o-animation: fadeout 2s; /* Opera */
	animation-fill-mode: forwards;
}
@keyframes fadeout {
	0% {
		opacity: 1;
	}
	60% {
		opacity: 1;
	}
	100% {
		opacity: 0;
	}
}
@-moz-keyframes fadeout {
	/* Firefox */
	0% {
		opacity: 1;
	}
	60% {
		opacity: 1;
	}
	100% {
		opacity: 0;
	}
}
@-webkit-keyframes fadeout {
	/* Safari and Chrome */
	0% {
		opacity: 1;
	}
	60% {
		opacity: 1;
	}
	100% {
		opacity: 0;
	}
}
@-o-keyframes fadeout {
	/* Opera */
	0% {
		opacity: 1;
	}
	60% {
		opacity: 1;
	}
	100% {
		opacity: 0;
	}
}
</style>
